module.exports = __webpack_public_path__ + "img/patch-check.66f6a7e1.svg";